module.exports = __webpack_public_path__ + "static/media/lastscan1.075f6f96.jpg";